import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/aidoo_aidooedu/app/GlobalProvider.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/aidoo_aidooedu/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/aidoo_aidooedu/lib/registry.js");
